export default __webpack_public_path__ + "static/media/CAD_PRO.4ef298da.png";